export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other'
};
